import React from 'react';

const RecentFeatures = ({ setActiveTab }) => {
    return (
        <div className="container mb-5">
            <div className="row">
                <div className="col-md-10 offset-md-1 p-4 shadow rounded bg-light">
                    <h4 className="mb-3 text-primary fs-5">Recent Features & Updates</h4>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="card">
                                <div className="card-body d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <h5 className="card-title fs-6">Audit Log DB Dump</h5>
                                        <p className="card-text mb-0 small">You can now request an audit log database dump for Forsyth Barr Secure Portal. But you need to be authorized by your administrator.</p>
                                    </div>
                                    <div className="ms-3">
                                        <button
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={() => setActiveTab('tab5')}
                                            style={{ whiteSpace: 'nowrap' }}
                                        >Go to FB Tab</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="card">
                                <div className="card-body d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <h5 className="card-title fs-6">DC Monitoring Whitelist</h5>
                                        <p className="card-text mb-0 small">You can now whitelist your IP for DC monitoring tools through the DC DevOps tab.</p>
                                    </div>
                                    <div className="ms-3">
                                        <button
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={() => setActiveTab('tab6')}
                                        >Go to DevOps Tab</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="card">
                                <div className="card-body d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <h5 className="card-title fs-6">Service Status Monitoring</h5>
                                        <p className="card-text mb-0 small">ECS service status is now automatically refreshed when accessing the DC Clients tab.</p>
                                    </div>
                                    <div className="ms-3">
                                        <button
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={() => setActiveTab('tab2')}
                                        >Check Services</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecentFeatures; 